export default "__VITE_ASSET__33475874__"